var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"form-control",attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.formattedNumber},on:{"keydown":_vm.checkNumber,"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }